<template>
  <section>
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      title="发送确认"
      width="770px"
      top="0"
      :center="true"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="csVisible"
    >
      <section class="p-6">
        <header class="mb-4 text-theme-black-850 text-medium-x font-bold">短信内容</header>
        <p class="my-3 px-4 py-4 text-theme-black-650 text-medium leading-snug bg-card-bg-gray" v-if="smsContent.length > 0">
          {{ smsContent }}
        </p>
        <header class="mt-6 mb-3 text-theme-black-850 text-medium-x font-bold">短信费用</header>
        <div class="h-60 overflow-auto">
          <data-table cell-class-name="truncate-table-cell-wrap" align="left" :data="csList" :columns="csColumns">
            <template #contentHeader>
              <div class="w-full flex items-center">
                <span class="mr-1">内容字符数</span>
                <el-tooltip
                  :content="`根据运营商规定，${smsConstantSize}个字符为一条短信，一个汉字和一个字母均占一个字符`"
                  effect="light"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </template>
          </data-table>
          <!-- <SmsPayForBalance /> -->
        </div>
      </section>
      <template #footer>
        <footer class="text-right">
          <el-button class="normal-button" size="small" @click="backStep">上一步</el-button>
          <el-button class="normal-button" type="primary" size="small" :loading="payInfoLoading" @click="confirmPay"
            >支付</el-button
          >
        </footer>
      </template>
    </el-dialog>
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      title="支付确认"
      width="770px"
      top="0"
      :center="true"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="payVisible"
    >
      <section class="p-6">
        <div class="mb-4 px-4 py-6 text-medium bg-card-bg-gray">
          <table class="w-full">
            <tr>
              <td class="pb-4 text-theme-black-650 text-medium whitespace-nowrap text-right">交易流水号：</td>
              <td class="w-10/12 pb-4 text-theme-black-850 text-medium">{{ payInfo.orderNo }}</td>
            </tr>
            <tr>
              <td class="pb-4 text-theme-black-650 text-medium whitespace-nowrap text-right">交易明细：</td>
              <td class="w-10/12 pb-4 text-theme-black-850 text-medium">{{ payInfo.type }}预付费</td>
            </tr>
            <tr>
              <td class="text-theme-black-650 text-medium whitespace-nowrap text-right">支付金额（元）：</td>
              <td class="w-10/12 text-theme-black-850 text-medium">{{ payInfo.total }}</td>
            </tr>
          </table>
          <p class="mt-4 text-small text-danger" v-if="isOneText">最小充值金额1元，不足1元时按1元充值</p>
        </div>
        <table class="w-full">
          <tr>
            <td class="pb-2 text-theme-black-850 text-medium whitespace-nowrap text-right">支付方式：</td>
            <td class="w-10/12 pb-2">
              <div class="w-full flex items-center text-medium">
                <el-radio class="mr-3 flex items-center">
                  <span class="text-theme">{{ balanceText }}（{{ balance }}）</span>
                </el-radio>
                <p v-if="payInfo.manager && !payInfo.businessUser"></p>
                <p v-else-if="!payInfo.manager && balanceLtTotal">余额不足，您没有充值权限，请向企业管理员提交充值审批。</p>
                <p v-else-if="!payInfo.manager && !payInfo.paymentAuthority">您没有支付权限，请向企业管理员提交支付审批</p>
                <p class="text-danger" v-else-if="balanceLtTotal">
                  可用余额不足请先
                  <span v-if="isNotPayRechargeBtns" class="text-theme select-none cursor-pointer">去充值</span>
                  <span v-else class="text-theme select-none cursor-pointer" @click="toRecharge">去充值</span>
                  ，充值后请刷新界面
                </p>
              </div>
            </td>
          </tr>
          <tr v-if="isBusinessManager && businessManager.length > 0">
            <td class="pb-2 text-theme-black-850 text-medium whitespace-nowrap text-right align-top">
              <div class="my-1 leading-snug">企业管理员：</div>
            </td>
            <td class="w-10/12 pb-2 text-theme-black-850 text-medium">
              <ul class="flex flex-col">
                <li class="my-1 leading-snug" v-for="bm of businessManager" :key="bm">{{ bm }}</li>
              </ul>
            </td>
          </tr>
        </table>
      </section>
      <template #footer>
        <footer class="text-right">
          <el-button class="normal-button" size="small" @click="backCSDialog">上一步</el-button>
          <template v-if="!isNotPayRechargeBtns">
            <el-button
              v-if="!balanceLtTotal"
              type="primary"
              size="small"
              :disabled="!isNotConfirmPayBtns"
              :loading="confirmPayLoading"
              @click="againConfirmPay"
              >确认支付</el-button
            >
            <el-button
              v-else
              class="normal-button"
              type="primary"
              size="small"
              :disabled="isNotPayRechargeBtns"
              @click="toRecharge"
              >去充值</el-button
            >
          </template>
          <el-button v-else class="normal-button" type="primary" size="small" @click="submitApproval">提交审批</el-button>
        </footer>
      </template>
    </el-dialog>
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      title="充值结果"
      width="770px"
      top="0"
      :center="true"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="payResVisible"
    >
      <section class="p-6 h-96 flex flex-col justify-center">
        <div class="mb-10 text-theme-black-850 text-medium text-center">
          <p class="my-2">支付完成前，请勿关闭此窗口。</p>
          <p class="my-2">支付完成后，请根据支付情况点击以下按钮。</p>
        </div>
        <div class="text-center">
          <el-button class="normal-button" size="small" @click="payResFailed">充值失败</el-button>
          <el-button type="primary" size="small" :loading="payResLoading" @click="payResSuccess">充值成功</el-button>
        </div>
      </section>
    </el-dialog>
  </section>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import GlobalConfig from '@/global/config'
import { setPayFlag, checkIsOk } from '@/assets/js/pay'
import { getAllUrl } from '@/mixins/getRechargeUrl'
import { getJurisdiction, getYuE } from '@/api/wenjuan/reward'
import { generateRecordInfo, createSmsRecord } from '@/api/pay/sms'
import { fridayMixins } from '@/mixins/publish'
import { confirmSendColumns, smsTempStatus, CONSTANT_SMS_SIZE } from '../config/sms-sending'
import { getQuerySmsAuditH } from '@/api/wenjuan/sample_new'
import { getSampleAnsForSms } from '@/api/wenjuan/offline'
import SmsPayForBalance from '@/views/survey/publish/sms-approve/SmsPayForBalance.vue'
export default {
  name: 'StepPaySend',
  mixins: [fridayMixins],
  components: {
    DataTable,
    SmsPayForBalance
  },
  inject: {
    prevStep: {
      default: null
    },
    nextStep: {
      default: null
    },
    source: {
      default: () => ({})
    }
  },
  data() {
    return {
      smsConstantSize: CONSTANT_SMS_SIZE,
      csVisible: true,
      csColumns: confirmSendColumns,
      payVisible: false,
      payInfoLoading: false,
      payInfo: {},
      confirmPayLoading: false,
      paySuccess: false,
      payResVisible: false,
      payResLoading: false,
      csList:[{

      }]
    }
  },
  computed: {
    smsContent() {
      return this.source.smsContent || ''
    },
    smsMoney() {
      return this.source.smsMoney || ''
    },
    // csList() {
    //   const recipientSize = this.source?.selectTotal || 0
    //   const billCount = Math.ceil(this.smsContent.length / CONSTANT_SMS_SIZE)

    //   getSampleAnsForSms({
    //     current:1,
    //     size:10,
    //     surveyId:GlobalConfig.getSurveyId()
    //   }).then(res=> {
    //     if(res.data.code === 0){
    //       console.log('res.data.data.tableData.total',res.data.data.tableData.total)
    //     }
    //   })
      
      
    //   const info = {
    //     contentSize: this.smsContent.length,
    //     billCount,
    //     recipientSize,
    //     smsUnitPrice: 0.1,
    //     total: (0.1 * recipientSize * billCount).toFixed(2)
    //   }
    //   return [info]
    // },
    balance() {
      return (this.payInfo.balance || 0).toFixed(2)
    },
    balanceLtTotal() {
      const { total } = this.csList[0]
      return this.balance - 0 < total - 0
    },
    isOneText() {
      const { total } = this.csList[0]
      return this.balanceLtTotal && total - this.balance < 1
    },
    balanceText() {
      return this.payInfo.businessUser ? '企业账户余额' : '账户余额'
    },
    businessManager() {
      return this.payInfo.businessManager || []
    },
    isBusinessManager() {
      const { manager, paymentAuthority } = this.payInfo
      if (manager) return false
      return !paymentAuthority || this.balanceLtTotal
    },
    isNotPayRechargeBtns() {
      const { manager, businessUser } = this.payInfo
      return !manager && businessUser
    },
    isNotConfirmPayBtns() {
      const { manager, businessUser, paymentAuthority } = this.payInfo
      return this.isNotPayRechargeBtns ? paymentAuthority : true
    }
  },
  methods: {
    backStep() {
      this.csVisible = false
      if (typeof this.prevStep === 'function') {
        this.prevStep()
      }
    },
    confirmPay() {
      const { total, billCount, recipientSize } = this.csList[0]
      const data = {
        orderSource: 3,
        amount: total,
        surveyId: GlobalConfig.getSurveyId(),
        awardType: 1,
        quantity: recipientSize * billCount,
        randomRedEnvelope: 0,
        totalAmount: total
      }
      this.payInfoLoading = true
      getJurisdiction(data)
        .then(res => {
          const result = res?.data?.data || {}
          ;(this.payInfo = {
            ...result,
            total
          }),
            (this.csVisible = false)
          this.payVisible = true
        })
        .catch(() => {
          this.$message.error('获取支付信息失败')
        })
        .finally(() => {
          this.payInfoLoading = false
        })
    },
    // 支付确认页
    backCSDialog() {
      this.payVisible = false
      this.csVisible = true
    },
    async againConfirmPay() {
      const { smsCheck } = this.source
      const req = {
        templateType: smsCheck,
        surveyId: GlobalConfig.getSurveyId(),
        smsParams: {
          title: this.$store.getters.title,
          timesStr: this.getTimesStr()
        }
      }
      if (smsCheck === smsTempStatus.COMPANY) {
        req.smsParams.companyName = GlobalConfig.getCompanyName()
      } else if (smsCheck === smsTempStatus.HAVE_REWARD) {
        req.smsParams.money = this.smsMoney
      }
      this.confirmPayLoading = true
      try {
        await generateRecordInfo(req)
        req.repeatable = true
        const res = await createSmsRecord(req)
        const { id } = res?.data?.data || {}
        this.source.smsRecord = {
          smsRecordId: id,
          sendResult: +res?.data?.code !== 2
        }
        this.payVisible = false
        if (this.payResVisible) {
          this.payResVisible = false
          setPayFlag(false)
        }
        if (typeof this.nextStep === 'function') {
          getQuerySmsAuditH({ surveyId: GlobalConfig.getSurveyId() }).then(res => {
            const auditStatus = res.data.data.auditStatus
            if (auditStatus === null || auditStatus === 3) {
              // 不需要二次审核
              this.nextStep(4)
              this.source.showlistNoRequest = true
              return
            }
            this.nextStep()
          })
        }
      } catch (e) {
        this.$message.error(e?.msg || '支付失败')
      } finally {
        this.confirmPayLoading = false
      }
    },
    toRecharge() {
      if (this.isNotPayRechargeBtns) return
      /* 
      // 2022-4-25 个人又可以购买短信
      if (`${GlobalConfig.getCompanyId()}` === '0') {
        this.$message.warning('个人用户无法购买短信')
        return
      } */
      getAllUrl.call(this)
      this.payVisible = false
      this.payResVisible = true
      this.paySuccess = false
      getYuE()
        .then(res => {
          const req = res?.data?.data || {}
          const expire = Date.now() + 120000
          setPayFlag(true)
          checkIsOk(
            expire,
            req,
            () => {
              this.$message.success('充值成功')
              this.paySuccess = true
              this.againConfirmPay()
            },
            () => {
              this.payResBack()
              this.$message.error('充值失败')
              this.paySuccess = false
            }
          )
        })
        .catch(() => {})
    },
    payResBack() {
      this.payResVisible = false
      this.payVisible = true
      setPayFlag(false)
    },
    // 充值结果
    payResFailed() {
      this.$message.error('您未支付成功')
      this.payResBack()
    },
    payResSuccess() {
      this.payResLoading = true
      setTimeout(() => {
        if (!this.paySuccess) {
          this.payResLoading = false
          this.payResFailed()
        }
      }, 5000)
    },
    submitApproval() {
      this.$message.warning('当期功能暂未开放，敬请期待')
    },
    getCsList(){
      const recipientSize = this.source?.selectTotal || 0
      const billCount = Math.ceil(this.smsContent.length / CONSTANT_SMS_SIZE)

      getSampleAnsForSms({
        current:1,
        size:10,
        surveyId:GlobalConfig.getSurveyId()
      }).then(res=> {
        if(res.data.code === 0){
          console.log('res.data.data.tableData.total',res.data.data.tableData.total)
          this.csList = [{
            contentSize: this.smsContent.length,
            billCount,
            recipientSize: res.data.data.tableData.total,
            smsUnitPrice: 0.1,
            total: (0.1 * recipientSize * billCount).toFixed(2)
          }]
          
        }
      })
    }
  },
  created(){
    this.getCsList()
  }
}
</script>
